import {
    apiRequest,
    indeksProfessionalitasDetail,
    indeksProfessionalitasDownloadPdf
} from "../../../../../services/adapters/kepegawaian/indeksProfessionalitas"

class FormRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", indeksProfessionalitasDetail, {
            params: query
        }, true)
    }

    fetchPdf = async (query) => {
        return await apiRequest("get", indeksProfessionalitasDownloadPdf, {
            params: query
        }, true)
    }
}

export default FormRepository